import "katex/dist/katex.min.css";

import type { FC } from "react";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Latex from "react-latex-next";
import { LinkContainer } from "react-router-bootstrap";

import { EnvelopeIcon } from "components";
import { EnvelopeDot } from "components/Envelope/EnvelopeDot";
import IconArrowForward from "components/Icons/IconArrowForward/IconArrowForward";
import ArrowIcon from "images/icons/10-arrow2.svg";

import type { TEnvelopeDotColor } from "components/Envelope/EnvelopeDot";
import { removeHTML } from "utils/removeHTML";

export interface IAssignment {
  envelopeType?: string | null;
  id: string;
  href?: string;
  text: string;
  testId: string | null;
  testOrder: number | null;
  dotColor?: TEnvelopeDotColor;
}

interface Props {
  assignment: IAssignment;
  envelopeChange?: {
    envelopeBefore: string;
    envelopeNow: string;
  };
}

const AssignmentBox: FC<Props> = ({ assignment, envelopeChange }) => {
  const { href, text, testId, testOrder, envelopeType } = assignment;
  const { t } = useTranslation(["assignments"]);

  if (!href) return null;

  return (
    <div className="assignment-box">
      <LinkContainer to={href}>
        <Nav.Link>
          <div className="assignment-box__content">
            <div>
              <p className="assignment-box__text-clamp">
                <Latex>{removeHTML(text)}</Latex>
              </p>
              <div className="assignment-box__content__inclusion">
                <div className="d-flex flex-direction-row align-items-center gap-2">
                  {assignment.dotColor ? <EnvelopeDot type={assignment.dotColor} /> : null}
                  <span>{t("topics.testIdentification", { ns: "assignments", testId, testOrder })}</span>
                </div>
                <>
                  {envelopeType === "string" ? (
                    <div>
                      <EnvelopeIcon type={envelopeType} />
                    </div>
                  ) : null}

                  {envelopeChange ? (
                    <div className="assignment-box__movements">
                      <EnvelopeIcon type={envelopeChange.envelopeBefore} />
                      <ArrowIcon className="assignment-box__arrow" />
                      <EnvelopeIcon type={envelopeChange.envelopeNow ?? envelopeChange.envelopeBefore} />
                    </div>
                  ) : null}
                </>
              </div>
            </div>
            <IconArrowForward />
          </div>
        </Nav.Link>
      </LinkContainer>
    </div>
  );
};

export default AssignmentBox;
